import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import moment from "moment";
// Constants - functions
import { pathHomePage, WEB_SERVICE_MIMS } from "../../config/constants";
import Axios from "../../config/axios";
import Loader from "../loader";
import PatientNavigation from "../patientNavigation";
import SoftwareMenu from "../softwareMenu";
import Title from "../title";
import PrescriptionCanvas from "./sections/prescriptionCanvas";
import NewPrescription from "./sections/newPrescription";
import ProtocolReports from "./sections/protocolReports";

const DiagnosisPrescriptions = () => {
  const [isLoadingPrescriptions, setIsLoadingPrescriptions] = useState(true);
  const [rechargePrescriptions, setRechargePrescriptions] = useState(false);
  const [prescribedDate, setPrescribedDate] = useState(moment().format("YYYY-MM-DD"));
  const [dateToPrescribe, setDateToPrescribe] = useState(moment().format("YYYY-MM-DD"));
  const [prescribedProtocols, setPrescribedProtocols] = useState([]);
  const [protocolsToPrescribe, setProtocolsToPrescribe] = useState([]);
  const [diagnosisObservation, setDiagnosisObservation] = useState("");
  const [diagnosisObservationToAdd, setDiagnosisObservationToAdd] = useState("");

  const { clinicianToken, patientId, software } = useParams();
  const [t] = useTranslation("global");

  // Get diagnosis prescriptions
  useEffect(() => {
    Axios("get", `${WEB_SERVICE_MIMS}/prescriptions/diagnosis/get/${patientId}/${software}`)
      .then(({ data }) => {
        const diagnosisPrescriptions = data.diagnosisPrescriptions;
        if (diagnosisPrescriptions.length) {
          setPrescribedDate(diagnosisPrescriptions[0].STARTING_DATE);
          setDateToPrescribe(diagnosisPrescriptions[0].STARTING_DATE);
          setPrescribedProtocols(diagnosisPrescriptions);
          setProtocolsToPrescribe(diagnosisPrescriptions);
          const diagnosisObservation = data.diagnosisObservation ? data.diagnosisObservation : "";
          setDiagnosisObservation(diagnosisObservation);
          setDiagnosisObservationToAdd(diagnosisObservation);
        }
        setIsLoadingPrescriptions(false);
      })
      .catch((error) => {
        console.log("Get diagnosis prescriptions: ", error);
      });

    return () => {
      setPrescribedDate(moment().format("YYYY-MM-DD"));
      setDateToPrescribe(moment().format("YYYY-MM-DD"));
      setPrescribedProtocols([]);
      setProtocolsToPrescribe([]);
      setDiagnosisObservation("");
      setDiagnosisObservationToAdd("");
      setIsLoadingPrescriptions(true);
    };
  }, [patientId, software, rechargePrescriptions]);

  const renderNewPrescriptionButton = () => {
    return (
      <NewPrescription
        prescribedDate={prescribedDate}
        dateToPrescribe={dateToPrescribe}
        setDateToPrescribe={setDateToPrescribe}
        prescribedProtocols={prescribedProtocols}
        protocolsToPrescribe={protocolsToPrescribe}
        setProtocolsToPrescribe={setProtocolsToPrescribe}
        diagnosisObservation={diagnosisObservation}
        diagnosisObservationToAdd={diagnosisObservationToAdd}
        setDiagnosisObservationToAdd={setDiagnosisObservationToAdd}
        setIsLoadingPrescriptions={setIsLoadingPrescriptions}
        rechargePrescriptions={rechargePrescriptions}
        setRechargePrescriptions={setRechargePrescriptions}
      />
    );
  };

  const renderPrescriptionsTitle = () => {
    if (prescribedProtocols.length) {
      return <Title title={t("diagnosisProtocols_sessionsList")} marginBottom="10px" />;
    }
  };

  const renderPrescriptionCanvas = () => {
    if (prescribedProtocols.length) {
      return (
        <PrescriptionCanvas
          title={t("diagnosisProtocols_titles_diagnosisSession")}
          isOnlyDisplayed={false}
          prescribedDate={prescribedDate}
          dateToPrescribe={dateToPrescribe}
          setDateToPrescribe={setDateToPrescribe}
          prescribedProtocols={prescribedProtocols}
          protocolsToPrescribe={protocolsToPrescribe}
          setProtocolsToPrescribe={setProtocolsToPrescribe}
          diagnosisObservation={diagnosisObservation}
          diagnosisObservationToAdd={diagnosisObservationToAdd}
          setDiagnosisObservationToAdd={setDiagnosisObservationToAdd}
          setIsLoadingPrescriptions={setIsLoadingPrescriptions}
          rechargePrescriptions={rechargePrescriptions}
          setRechargePrescriptions={setRechargePrescriptions}
        />
      );
    }
  };

  const isLoading = isLoadingPrescriptions;

  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <>
          <PatientNavigation patientId={patientId} section={software} />
          <SoftwareMenu
            prescriptionsPath={`${pathHomePage}/prescriptions/${software}/${clinicianToken}/${patientId}`}
            diagnosisPrescriptionsPath={`${pathHomePage}/diagnosis-prescriptions/${clinicianToken}/${patientId}/${software}`}
            questionnairePath={`${pathHomePage}/emotional-questions/${clinicianToken}/${patientId}/${software}`}
            messagesPath={`${pathHomePage}/messages/${clinicianToken}/${patientId}/${software}`}
          />
          {renderNewPrescriptionButton()}
          {renderPrescriptionsTitle()}
          {renderPrescriptionCanvas()}
          <ProtocolReports />
        </>
      )}
    </>
  );
};

export default DiagnosisPrescriptions;
